<div class="min-w-[430px] p-6">
  <h2
    class="text-xl font-bold leading-tight text-center tracking-tight text-gray-900 md:text-2xl"
  >
    {{ 'auth.resetPassword' | transloco }}
  </h2>
  <div class="flex flex-col gap-y-2 my-6">
    <tui-input [formControl]="form.controls.email" tuiTextfieldSize="l"
      >Email</tui-input
    >
    @if (form.controls.token.value && form.controls.email.value) {
      <tui-input-password
        [formControl]="form.controls.password"
        tuiTextfieldSize="l"
        >{{ 'auth.password' | transloco }}</tui-input-password
      >
      <tui-input-password
        [formControl]="form.controls.passwordConfirm"
        tuiTextfieldSize="l"
        >{{ 'auth.confirmPassword' | transloco }}</tui-input-password
      >
    }
  </div>
  <button
    [showLoader]="(loading$ | async)!"
    (click)="submit()"
    [disabled]="!form.valid"
    class="w-full"
    tuiButton
    appearance="primary"
  >
    {{
      (form.controls.token.value ? 'auth.apply' : 'auth.sendResetMessage')
        | transloco
    }}
  </button>
</div>
